import React from "react";
import {useTranslation} from "react-i18next";
import {stringToBool} from "../../../utilities/helperFunctions";
import OptionToggleRow from "./OptionToggleRow";
import initialUserSettings from "../../../models/user/initialUserSettings";
import {userSettings} from "../../../utilities/constants";

function TroubleshootOption(props) {
    const {setting: troubleshoot, updateSetting} = props;
    const {t} = useTranslation(['troubleshoot']);

    function toggleSetting(event) {
        const {name: setting, checked} = event.currentTarget.dataset;
        updateSetting(setting, stringToBool(checked));
    }

    return (
        <>
            <div className="options-table display-input">
                <div className="table-header-group">
                    <div className="table-header"/>
                    <div className="table-header"/>
                </div>

                <div className="table-row-group">
                    {Object
                        .keys(initialUserSettings.get(userSettings.TROUBLESHOOT))
                        .map(key =>
                            <OptionToggleRow key={key} label={t(`troubleshoot:label.${key}`)} useTrElement={false}
                                name={key} checked={troubleshoot[key]} onClick={toggleSetting}/>
                        )
                    }
                </div>
            </div>
        </>
    )
}

export default TroubleshootOption;